import Grid from "@mui/material/Grid";
import React, { useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import IconButton from "@mui/material/IconButton";
import EpmsImage from "@/react/components/Common/EpmsImage";
import { useFullscreenImage } from "@/react/Webshop/Mobile/hooks/useFullscreenImage";
import YearbookPoseIcon from "@mui/icons-material/MenuBook";
import DownloadIcon from "@mui/icons-material/CloudDownload";
import RetouchedIcon from "@mui/icons-material/PhotoFilter";
import FullscreenImageDialog from "@/react/Webshop/Mobile/Components/FullscreenImageDialog";
import { generatePath } from "react-router";
import ChoosePictureBackgroundDialog from "@/react/Webshop/Mobile/Pages/MyPictureSet/Components/ChooseBackgroundDialog";
import useMobileRoutes from "@/react/Webshop/Mobile/hooks/useMobileRoutes";
import { Link } from "react-router-dom";
import { usePriceList } from "@/react/Webshop/providers/PriceListProvider";
import { getPictureIsBought } from "@/react/Webshop/utils/digitalPictureUtils";
import PictureRetouchInformationDialog from "@/react/Webshop/Mobile/Pages/MyPictureSet/Components/PictureRetouchInformationDialog";
import { pictureIsYearbookPose } from "@/react/Webshop/utils/pictureUtils";
import useCopyrightDialog from "@/react/Webshop/hooks/useCopyrightDialog";
const useStyles = makeStyles((theme) => ({
    list: {
        width: "100%",
        overflow: "auto",
        alignItems: "center",
        listStyle: "none",
        margin: 0,
        padding: 0,
        flexGrow: 1,
        display: "flex",
    },
    listItem: {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& > img, & > canvas": {
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
            border: `1px solid ${theme.palette.primary.main}`,
            backgroundColor: "white",
        },
    },
}));
function PictureSetPictureList({ pictures, pictureSet, }) {
    const classes = useStyles();
    const { open, fullscreenImage, origin, openImage, closeImage } = useFullscreenImage();
    const { getCopyrightTriggerProps, copyrightDialog } = useCopyrightDialog();
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, spacing: 2 }, pictures.map((picture) => (React.createElement(Grid, { key: picture.uuid, size: { xs: 6, sm: 4, md: 4 }, className: classes.listItem },
            React.createElement(Picture, { picture: picture, openImage: openImage, pictureSet: pictureSet, subjectUuid: pictureSet.uuid, pictureContextMenuProps: getCopyrightTriggerProps() }))))),
        React.createElement(FullscreenImageDialog, { open: open, onClose: closeImage, transformOrigin: origin, picture: fullscreenImage }),
        copyrightDialog));
}
const Picture = ({ picture, subjectUuid, pictureSet, openImage, pictureContextMenuProps, }) => {
    const [chooseBackground, setChooseBackground] = useState(false);
    const routes = useMobileRoutes();
    const priceList = usePriceList();
    const [showRetouchDialog, setShowRetouchDialog] = useState(false);
    const classes = useStyles();
    const downloadFile = () => {
        if (picture.greenscreen) {
            setChooseBackground(true);
        }
        else {
            const link = generatePath(routes["pictureset.download.file"].path, {
                uuid: picture.uuid,
            });
            document.location.href = link;
        }
    };
    const isYearbookPose = pictureIsYearbookPose(picture, pictureSet);
    const isDownloadable = getPictureIsBought(picture, pictureSet, priceList);
    return (React.createElement(React.Fragment, null,
        React.createElement(EpmsImage, Object.assign({ uuid: picture.uuid, size: 640 }, (pictureContextMenuProps !== null && pictureContextMenuProps !== void 0 ? pictureContextMenuProps : {}), { onClick: (e) => openImage(e, picture) })),
        isYearbookPose && (React.createElement(IconButton, { sx: {
                position: "absolute",
                top: 1,
                right: 1,
                backgroundColor: "primary.main",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "common.white",
                p: "5px",
                "& svg": {
                    fontSize: "24px",
                },
            }, color: "primary", component: Link, to: generatePath(routes["myaccount.picturesets.pictureset.yearbookpose"].path, { uuid: subjectUuid }) },
            React.createElement(YearbookPoseIcon, null))),
        isDownloadable && (React.createElement(IconButton, { sx: {
                position: "absolute",
                bottom: 1,
                left: 1,
                backgroundColor: "primary.main",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "common.white",
                p: "5px",
                "& svg": {
                    fontSize: "24px",
                },
            }, onClick: () => downloadFile() },
            React.createElement(DownloadIcon, null))),
        picture.userBoughtRetouch && (React.createElement(IconButton, { sx: {
                position: "absolute",
                top: 1,
                left: 1,
                backgroundColor: "primary.main",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "common.white",
                p: "5px",
                "& svg": {
                    fontSize: "24px",
                },
            }, onClick: () => setShowRetouchDialog(true) },
            React.createElement(RetouchedIcon, null))),
        chooseBackground && (React.createElement(ChoosePictureBackgroundDialog, { picture: picture, onClose: () => setChooseBackground(false) })),
        showRetouchDialog && (React.createElement(PictureRetouchInformationDialog, { picture: picture, onClose: () => setShowRetouchDialog(false) }))));
};
export default PictureSetPictureList;
